/**
 * Sparkline — мини-график MRR (инлайн-SVG: линия + мягкая заливка). `tone`
 * brand — на светлой карточке, light — на тёмном hero. Полноценные графики
 * раздела «Тренды» — на Recharts.
 */

type SparklineProps = {points: number[]; tone?: 'brand' | 'light'};

const W = 300;
const H = 44;
const COLORS = {
  brand: {line: '#2C5CDB', fill: '#2C5CDB', op: 0.16},
  light: {line: '#8FB4FF', fill: '#6FA0FF', op: 0.35},
};

export const Sparkline = ({points, tone = 'brand'}: SparklineProps) => {
  const c = COLORS[tone];
  const id = `spark-${tone}`;
  const min = Math.min(...points);
  const max = Math.max(...points);
  const range = max - min || 1;
  const step = W / (points.length - 1);
  const line = points
    .map((p, i) => `${(i * step).toFixed(1)},${(H - 3 - ((p - min) / range) * (H - 6)).toFixed(1)}`)
    .join(' ');

  return (
    <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" className="block w-full">
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor={c.fill} stopOpacity={c.op} />
          <stop offset="1" stopColor={c.fill} stopOpacity="0" />
        </linearGradient>
      </defs>
      <polygon points={`${line} ${W},${H} 0,${H}`} fill={`url(#${id})`} />
      <polyline
        points={line}
        fill="none"
        stroke={c.line}
        strokeWidth={2}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
};
